import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Nullable } from '../../utils/types';

interface Props {
  onVersionChanged?: () => any;
}

const CHECK_VERSION_MINUTES = 3;

const getAppVersion = async (): Promise<Nullable<string>> => {
  try {
    const response = await axios.get('/app.json');
    if (response.data && response.data.version) {
      return response.data.version;
    }
  } catch (e) {}
  return null;
};

let timer: any = null;
let lastCheck = 0;

const VersionCheck: React.FC<Props> = ({ onVersionChanged }) => {
  const [currentVersion, setCurrentVersion] = useState<string>();

  const checkVersion = useCallback(async () => {
    const now = new Date().getTime();
    if (lastCheck === 0 || now - lastCheck >= CHECK_VERSION_MINUTES * 60 * 1000) {
      lastCheck = now;
      const version = await getAppVersion();

      if (!version) {
        return;
      }

      if (!currentVersion) {
        setCurrentVersion(version);
      } else if (currentVersion !== version && onVersionChanged) {
        onVersionChanged();
      }
    }
    timer = setTimeout(checkVersion, 5000);
  }, [currentVersion, onVersionChanged]);

  useEffect(() => {
    checkVersion();
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [checkVersion]);

  return <></>;
};

export default VersionCheck;
